import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { openInfoToaster } from 'helpers/toaster.helpers'
import { TRANSACTION_TABS } from 'constants/index'
import { getHighRollers } from 'redux-thunk/thunk/casino.thunk'
import AllBets from './components/AllBets/index'
import HighRoller from './components/HighRoller/index'

const TransactionsTable = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [tab, setTab] = useState(TRANSACTION_TABS.ALL_BETS)

  useEffect(() => {
    if (tab === TRANSACTION_TABS.HIGH_ROLLER) {
      dispatch(getHighRollers({ limit: 10 }))
    }
  }, [tab])

  return (
    <>
      <section className='table-section'>
        <div className='inner-heading m-0 d-block  d-lg-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center mb-3 mb-lg-0'>
            <img src='/assets/images/homePage/white-refresh.svg' alt='Live' />
            <h4 className='text-uppercase'>{t('liveBets')}</h4>
          </div>
          <div className='heading-right-listing'>
            <ul className='nav nav-tabs d-flex align-items-center m-0' role='tablist'>
              <li
                className={`nav-item ${tab === TRANSACTION_TABS.ALL_BETS ? 'active' : ''}`}
                role='presentation'
              >
                <NavLink
                  to='#'
                  onClick={(e) => {
                    setTab(TRANSACTION_TABS.ALL_BETS)
                  }}
                >
                  {t('allBets')}
                </NavLink>
              </li>
              <li
                className={`nav-item ${tab === TRANSACTION_TABS.HIGH_ROLLER ? 'active' : ''}`}
                role='presentation'
              >
                <NavLink
                  to='#'
                  onClick={(e) => {
                    setTab(TRANSACTION_TABS.HIGH_ROLLER)
                  }}
                >
                  {t('highRollers')}
                </NavLink>
              </li>
              <li className='nav-item' role='presentation'>
                <NavLink
                  to='#'
                  onClick={(e) => {
                    openInfoToaster({ message: 'Coming Soon!' })
                  }}
                >
                  {t('luckyBets')}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div className='tab-content'>
          <AllBets tab={tab} />
          <HighRoller tab={tab} />
        </div>
      </section>
      {/* <div className='d-flex justify-content-between'>
        <ul className='nav nav-tabs align-item-center flex-nowrap text-nowrap overflow-auto me-2 me-md-0 mb-2 mt-4' id='ex1' role='tablist'>
          <li className='nav-item' role='presentation'>
            <a
              role='tab'
              className={`nav-link ${tab === TABLE_TABS.VIVA_ORIGINALS ? 'active' : ''}`}
              onClick={(e) => {
                setTab(TABLE_TABS.VIVA_ORIGINALS)
              }}
            >
              Viva originals
            </a>
          </li>
          <li className='nav-item' role='presentation'>
            <a
              role='tab'
              className={`nav-link ${tab === TABLE_TABS.CASINO ? 'active' : ''}`}
              onClick={(e) => {
                setTab(TABLE_TABS.CASINO)
              }}
            >
              Casino
            </a>
          </li>
          <li className='nav-item' role='presentation'>
            <a
              role='tab'
              className={`nav-link ${tab === TABLE_TABS.SPORTS_BOOK ? 'active' : ''}`}
              onClick={(e) => {
                setTab(TABLE_TABS.SPORTS_BOOK)
              }}
            >
              SportsBook
            </a>
          </li>
        </ul>
        <select
          onChange={(e) => {
            setNumberOfRecords(e.target.value)
          }}
          className='form-select select-box d-none d-md-block'
          aria-label='Default select example'
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={30}>30</option>
          <option value={40}>40</option>
        </select>
      </div>
      <section className='section-space'>
        <div className='tab-content'>
          <div
            className={`tab-pane fade show ${tab === TABLE_TABS.VIVA_ORIGINALS ? 'active' : ''}`}
            id='lobby'
            role='tabpanel'
          >
            <div className='table-responsive'>
              <table className='table table-striped table-default'>
                <thead>
                  <tr>
                    <th scope='col' className='text-uppercase text-center'>
                      Game
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Player
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Time
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Event ID
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Bet
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Multiplier
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Win
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {customGameTransactions?.count > 0
                    ? (
                        customGameTransactions?.rows?.map((data) => (
                          <tr key={data.betId}>
                            <td className='text-center'>
                              <img src={CUSTOM_GAMES_ICONS[data.game.name]} alt='brazilian real' className='me-2' />{startCase(data.game.name)}
                            </td>
                            <td className='text-center'>
                              <span>{data?.user?.userName ? startCase(data?.user?.userName) : 'Hidden'}</span>
                            </td>
                            <td className='text-center'>{moment.utc(data.betCreatedAt).format('h:mm A')}</td>
                            <td className='text-center'>{data.betId}</td>
                            <td className='text-center'>
                              <div className='cashout-column'>
                                {data.bet?.toFixed(2)}
                              </div>
                              <img src='/assets/images/stock-images/currency-brl.png' height='20px' width='20px' className='ms-2' alt='brazilian real' />
                            </td>
                            <td className='text-center'>{(Number(+data.win / +data.bet))?.toFixed(2)}x</td>
                            <td className={`text-center ${data.win ? 'table-data-success' : ''}`}>
                              <div className='cashout-column'>
                                {data.win?.toFixed(2)}
                              </div>
                              <img src='/assets/images/stock-images/currency-brl.png' height='20px' width='20px' className='ms-2' alt='brazilian real' />
                            </td>
                          </tr>
                        )))
                    : (
                      <tr>
                        <td colSpan={7} className='text-center'>
                          {loading ? <Loader variant={LOADER_HANDLER_TYPES.table} /> : 'Data Not Found'}
                        </td>
                      </tr>
                      )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`tab-pane fade show ${tab === TABLE_TABS.CASINO ? 'active' : ''}`}
            id='lobby'
            role='tabpanel'
          >
            <div className='table-responsive'>
              <table className='table table-striped table-default'>
                <thead>
                  <tr>
                    <th scope='col' className='text-uppercase text-center'>
                      Game
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Player
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Time
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Bet Amount
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Win Amount
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Action Type
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {casinoTransactions?.count > 0
                    ? (
                        casinoTransactions?.rows?.map((data) => (
                          <tr key={`${data?.transactionInfo?.RoundId}${data?.bet}`}>
                            <td className='text-center'>{startCase(data?.casino?.gameName)}</td>
                            <td className='text-center'>
                              <span>{data?.user?.userName ? startCase(data?.user?.userName) : 'Hidden'}</span>
                            </td>
                            <td className='text-center'>{moment.utc(data?.createdAt).format('h:mm A')}</td>
                            <td className='text-center'>
                              <div className='cashout-column'>{data?.bet}</div>
                              <img src='/assets/images/stock-images/currency-brl.png' height='20px' width='20px' className='ms-2' alt='brazilian real' />
                            </td>
                            <td className={`text-center ${data?.win ? 'table-data-success' : ''}`}>
                              <div className='cashout-column'>  {data?.win}</div>
                              <img src='/assets/images/stock-images/currency-brl.png' height='20px' width='20px' className='ms-2' alt='brazilian real' />
                            </td>
                            <td className='text-center'>{data?.actionType?.replace(/([a-z])([A-Z])/g, '$1 $2')}</td>
                          </tr>
                        )))
                    : (
                      <tr>
                        <td colSpan={5} className='text-center'>
                          {loading ? <Loader variant={LOADER_HANDLER_TYPES.table} /> : 'Data Not Found'}
                        </td>
                      </tr>
                      )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`tab-pane fade show ${tab === TABLE_TABS.SPORTS_BOOK ? 'active' : ''}`}
            id='lobby'
            role='tabpanel'
          >
            <div className='table-responsive'>
              <table className='table table-striped table-default'>
                <thead>
                  <tr>
                    <th scope='col' className='text-uppercase text-center'>
                      Game ID
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Player
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Time
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Transaction ID
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Amount
                    </th>
                    <th scope='col' className='text-uppercase text-center'>
                      Action Type
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sportsBookTransactions?.count > 0
                    ? (
                        sportsBookTransactions?.rows?.map((data) => (
                          <tr key={data.transactionId}>
                            <td className='text-center'>{data?.gameId}</td>
                            <td className='text-center'>
                              <span>{data?.user?.userName ? startCase(data?.user?.userName) : 'Hidden'}</span>
                            </td>
                            <td className='text-center'>{moment.utc(data.betCreatedAt).format('h:mm A')}</td>
                            <td className='text-center'>{data.transactionId}</td>
                            <td className='text-center'>
                              <div className='cashout-column'>
                                {data.amount}
                              </div>
                              <img src='/assets/images/stock-images/currency-brl.png' height='20px' width='20px' className='ms-2' alt='brazilian real' />
                            </td>
                            <td className='text-center'>{data.actionType}</td>
                          </tr>
                        )))
                    : (
                      <tr>
                        <td colSpan={7} className='text-center'>
                          {loading ? <Loader variant={LOADER_HANDLER_TYPES.table} /> : 'Data Not Found'}
                        </td>
                      </tr>
                      )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section> */}
    </>
  )
}

export default React.memo(TransactionsTable)
